import { useRef, useMemo } from 'react';
import { getCombinedChartOptions } from '../utils/chartHelpers';

export const useChart = ({ type, options }) => {
  const chartRef = useRef(null);

  const combinedOptions = useMemo(
    () => getCombinedChartOptions(type, options),
    [type, options]
  );

  return {
    chartRef,
    combinedOptions,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Chart/hooks/useChart.js